import { HomeIcon, UserGroupIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import { USER_ROLE } from '../../types/auth';
import { NavigationConfig } from './types';

export const superAdminNav: NavigationConfig = [
	{
		items: [
			{
				icon: HomeIcon,
				label: 'Dashboard',
				path: '/dashboard',
				roles: [USER_ROLE.SUPER_ADMIN],
			},
			{
				icon: UserGroupIcon,
				label: 'Providers',
				path: '/providers',
				roles: [USER_ROLE.SUPER_ADMIN],
			},
		],
	},
	{
		title: 'Configuration',
		items: [
			{
				icon: Cog6ToothIcon,
				label: 'Settings',
				path: '/settings',
				roles: [USER_ROLE.SUPER_ADMIN],
			},
		],
	},
];
